import mixinUILifeCycle from './UILifeCycle'
import {UIEvent} from "../const/Event"
export default class BaseContainer extends PIXI.Container {
    constructor() {
        super();

        this._explictWidth = 0;
        this._explictHeight = 0;

        this.initLifeCycle();
        this.rgEvent(UIEvent.SIZE_CHANGED, true, this._onSizeChanged);
    }

    get width(){
        return this._explictWidth || super.width;
    }
    set width(val){
        if(this._explictWidth == val){return;}
        this._explictWidth = val;
        this.event(UIEvent.SIZE_CHANGED);
    }
    get height(){
        return this._explictHeight || super.height;
    }
    set height(val){
        if(this._explictHeight == val){return;}
        this._explictHeight = val;
        this.event(UIEvent.SIZE_CHANGED);
    }

    resize(w, h){
        this.width  = w;
        this.height = h;
    }

    _onSizeChanged(){
    }
}
mixinUILifeCycle(BaseContainer.prototype);



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/BaseContainer.js